import React, { useState, useEffect } from 'react';
import './ArchivoPage.css';
import Modal from '../Modal/Modal'; // <-- 1. Importa el componente Modal

const ArchivoPage = () => {
  // ... (los estados para archivos, búsqueda, etc., se quedan igual)
  const [publicos, setPublicos] = useState([]);
  const [protegidos, setProtegidos] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // --- 2. Nuevo estado para controlar la visibilidad del modal ---
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  // ... (la función useEffect para cargar archivos públicos se queda igual)
  useEffect(() => {
    const fetchPublicArchivos = async () => {
      setIsLoading(true);
      const url = `https://api.interventorsisgafr.com/api/archivos?search=${searchTerm}`;
      try {
        const response = await fetch(url);
        const data = await response.json();
        setPublicos(data);
      } catch (error) { console.error("Error al cargar archivos:", error); }
      finally { setIsLoading(false); }
    };
    const delayDebounceFn = setTimeout(() => { fetchPublicArchivos(); }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);


  const handleUnlock = async (e) => {
    e.preventDefault();
    setError('');
    setIsUnlocked(false);
    setProtegidos([]);
    try {
      const response = await fetch('https://api.interventorsisgafr.com/api/archivos/protected', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.msg);
      
      setProtegidos(data);
      setIsUnlocked(true);
      setShowPasswordModal(false); // Cierra el modal si la contraseña es correcta
      setPassword(''); // Limpia el campo de contraseña
    } catch (err) {
      // Mantenemos el error dentro del modal para que el usuario lo vea
      setError(err.message);
    }
  };

  const getFileIcon = (fileType) => {
    if (fileType.includes('pdf')) return '📄';
    if (fileType.includes('sheet') || fileType.includes('excel')) return '📊';
    return '📁';
  }

  const ArchivoCard = ({ archivo }) => (
    <div className="archivo-card">
      <div className="archivo-icon">{getFileIcon(archivo.file_type)}</div>
      <div className="archivo-info">
        <h3>{archivo.display_name}</h3>
        <div className="archivo-actions">
          <a href={`https://api.interventorsisgafr.com/${archivo.file_path}`} target="_blank" rel="noopener noreferrer" className="action-btn view">Visualizar</a>
          <a href={`https://api.interventorsisgafr.com/${archivo.file_path}`} download className="action-btn download">Descargar</a>
        </div>
      </div>
    </div>
  );

  return (
    <> {/* Usamos un fragmento para poder tener elementos al mismo nivel que el Modal */}
      <div className="archivo-container">
        <div className="archivo-header">
          <h1>Archivo de Documentos</h1>
          {/* --- 3. El botón ahora abre el Modal --- */}
          <button className="ani-access-btn" onClick={() => setShowPasswordModal(true)}>
            Acceso ANI
          </button>
        </div>
        
        {isUnlocked && (
          <div className="protected-files">
            <h2>Documentos Protegidos Desbloqueados</h2>
            <div className="archivo-grid">
              {protegidos.length > 0 ? (
                  protegidos.map((archivo) => <ArchivoCard key={archivo.id} archivo={archivo} />)
              ) : (
                  <p>No se encontraron documentos protegidos.</p>
              )}
            </div>
          </div>
        )}

        <hr className="divider" />
        <h2>Documentos Públicos</h2>
        <div className="search-bar">
          <input
            type="text"
            placeholder="Buscar en documentos públicos..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        
        {isLoading ? <p>Cargando...</p> : (
          <div className="archivo-grid">
            {publicos.map((archivo) => <ArchivoCard key={archivo.id} archivo={archivo} />)}
          </div>
        )}
      </div>

      {/* --- 4. MODAL PARA LA CONTRASEÑA --- */}
      <Modal show={showPasswordModal} onClose={() => setShowPasswordModal(false)}>
        <div className="password-modal-content">
          <h3>Acceso a Documentos de la ANI</h3>
          <p>Ingrese la contraseña proporcionada para ver los archivos protegidos.</p>
          <form onSubmit={handleUnlock}>
            <input 
              type="password" 
              value={password} 
              onChange={e => setPassword(e.target.value)} 
              placeholder="••••••" 
              required 
              autoFocus
            />
            {error && <p className="error-message-modal">{error}</p>}
            <button type="submit" className="unlock-button">Desbloquear</button>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default ArchivoPage;